import ChargeHelper from 'features/Charge/chargeHelper';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import DialogAddChargeModelView from '../DialogAddChargeModelView';

ChargeModelListView.propTypes = {
  showFullUI: PropTypes.bool,
  chargeBrandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function ChargeModelListView({ showFullUI = false, chargeBrandId }) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const [chargeBrandDetail, setChargeBrandDetail] = useState(null);
  useEffect(() => {
    if (chargeBrandId) {
      ChargeHelper.API.requestGetChargeBrandList({ brandId: chargeBrandId }).then((response) => {
        const brand = response.brands.find((item) => item.brandId == chargeBrandId);
        setChargeBrandDetail(brand);
      });
    }
  }, [chargeBrandId]);
  const [filter, setFilter] = useState(ChargeHelper.Filter.chargeModelList);
  const [chargeModelList, setChargeModelList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    setIsLoading(true);
    ChargeHelper.API.requestGetChargeModelList({
      ...filter,
      brandId: chargeBrandId,
    })
      .then((response) => {
        setChargeModelList(response.models);
        setTotal(response.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [filter, chargeBrandId]);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'LOGO',
        name: UIHelper.buildTableColumn('Ảnh'),
        selector: (row) =>
          UIHelper.buildAvatar(Utils.getFullUrl(row?.image), 40, null, false, false),
        width: '70px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'MODEL_NAME',
        name: UIHelper.buildTableColumn('Tên dòng trụ sạc'),
        selector: (row) => row?.name,
        minWidth: '180px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'VEHICLE_TYPE',
        name: UIHelper.buildTableColumn('Loại phương tiện'),
        selector: (row) =>
          _.find(ChargeHelper.Data.vehicleTypeOptions, (item) => item.value === row?.vehicleType)
            ?.name,
        minWidth: '140px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'POINT_TYPE',
        name: UIHelper.buildTableColumn('Loại trụ sạc'),
        selector: (row) => row?.type,
        minWidth: '100px',
        style: tableStyle.columns.normal,
      },
      // {
      //   name: (
      //     <span
      //       className="letter-spacing-unset"
      //       style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
      //     >
      //       Số vòi sạc
      //     </span>
      //   ),
      //   selector: (row) => row?.connectors,
      //   minWidth: '90px',
      //   right: true,
      //   style: tableStyle.columns.normal,
      // },
      // {
      //   name: (
      //     <span
      //       className="letter-spacing-unset"
      //       style={UIHelper.buildFontStyle('600', '12px', AppColors.gray[900])}
      //     >
      //       Loại vòi sạc
      //     </span>
      //   ),
      //   selector: (row) => row?.connectorType,
      //   minWidth: '120px',
      //   style: tableStyle.columns.normal,
      // },
      {
        id: 'POWER',
        name: UIHelper.buildTableColumn('Công suất', 'kW'),
        selector: (row) => (Utils.isValid(row?.power) ? Utils.formatNumber(row?.power / 1000) : ''),
        minWidth: '90px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'VOLTAGE',
        name: UIHelper.buildTableColumn('Điện áp', 'V'),
        selector: (row) => (Utils.isValid(row?.voltage) ? Utils.formatNumber(row?.voltage) : ''),
        minWidth: '90px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'PROTOCOL',
        name: UIHelper.buildTableColumn('Giao thức'),
        selector: (row) => row?.protocol,
        minWidth: '120px',
        style: tableStyle.columns.normal,
      },
      {
        id: 'PRICE',
        name: UIHelper.buildTableColumn('Đơn giá', 'VNĐ'),
        selector: (row) => row?.price ? Utils.formatNumber(row?.price) : '',
        minWidth: '180px',
        right: true,
        style: tableStyle.columns.normal,
      },
      {
        id: 'DESCRIPTION',
        name: UIHelper.buildTableColumn('Mô tả'),
        selector: (row) => {
          return (
            <KTTooltip text={row?.description}>
              <div className="my-2 text-ellipsis-2-lines" style={{ whiteSpace: 'normal' }}>
                {row?.description}
              </div>
            </KTTooltip>
          );
        },
        minWidth: '400px',
        style: tableStyle.columns.normal,
      },
      {
        name: UIHelper.buildTableColumn('Thao tác'),
        maxWidth: '110px',
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        center: true,
        cell: (row) => {
          return UIHelper.buildMoreActionsButton(buildMoreActions(row), true);
        },
      },
    ];
  }, [isAdmin]);

  // MARK: ---- METHODS ----
  const buildMoreActions = (row) => {
    const actions = [];
    // xem chi tiet
    // actions.push({
    //   text: 'Xem chi tiết',
    //   iconElement: <i className="fa-regular fa-eye" style={{ fontSize: '1.1rem' }} />,
    //   click: () => {
    //     handleAddNew(row);
    //   },
    // });
    if (isAdmin) {
      // chinh sua
      actions.push({
        text: 'Chỉnh sửa',
        iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          handleAddNew(row);
        },
      });
      // xoa
      actions.push({
        text: 'Xoá',
        iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
        click: () => {
          handleDelete(row);
        },
      });
    }
    return actions;
  };

  const handleRefresh = () => {
    setFilter({ ...ChargeHelper.Filter.chargeModelList });
  };
  const handleDelete = (row) => {
    ChargeHelper.UI.showDialogConfirmDeleteChargeModel(row, () => {
      handleRefresh();
    });
  };
  const handleAddNew = (row) => {
    AppCustomDialogHelper.show(
      !!row ? 'Sửa dòng trụ sạc (model)' : 'Thêm dòng trụ sạc (model)',
      <DialogAddChargeModelView
        item={row}
        chargeBrandId={chargeBrandId}
        onCancel={() => AppCustomDialogHelper.hide()}
        onDone={() => {
          AppCustomDialogHelper.hide();
          handleRefresh();
        }}
      />,
      'lg',
      false,
      true
    );
  };

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách hãng sản xuất trụ sạc',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết hãng sản xuất trụ sạc' },
        ])}
      </div>
      <div className="px-4 my-4">
        {UIHelper.buildCard(
          <div>
            {/* header */}
            {showFullUI && (
              <div className="px-4 pt-4 d-flex justify-content-between align-items-center">
                {/* title */}
                <div className="d-flex align-items-center gap-2">
                  {UIHelper.buildAvatar(
                    chargeBrandDetail?.logo ? Utils.getFullUrl(chargeBrandDetail?.logo) : null,
                    44,
                    AppResource.images.chargeConnectorTypes.imgBrandLogoDefault,
                    false,
                    false
                  )}
                  <div className="d-flex flex-column align-items-start">
                    <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                      Hãng: {chargeBrandDetail?.name}
                    </span>
                    <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                      Tổng số:{' '}
                      <span style={{ color: AppColors.primary }}>
                        {Utils.formatNumber(total)} dòng trụ sạc
                      </span>
                    </span>
                  </div>
                </div>

                {/* actions */}
                {isAdmin &&
                  UIHelper.buildGreenButton(
                    'Thêm mới',
                    handleAddNew,
                    <i className="fa-regular fa-circle-plus" />
                  )}
              </div>
            )}
            {/* body */}
            <div className={`${showFullUI ? 'p-4' : 'pt-4'}`}>
              {/* filter */}
              <div className="row m-0">
                {/* tim kiem */}
                <div className="pl-0 pr-0 pr-md-4 col-xl-3 col-md-4 mb-3">
                  {UIHelper.buildFormLabel('Tìm kiếm')}
                  <KTFormSearch
                    name="search"
                    placeholder="Theo tên dòng trụ sạc, mô tả..."
                    value={ChargeHelper.Filter.chargeModelList.q}
                    onSubmit={(text) => {
                      ChargeHelper.Filter.chargeModelList = {
                        ...ChargeHelper.Filter.chargeModelList,
                        page: 0,
                        q: text,
                      };
                      handleRefresh();
                    }}
                  />
                </div>
              </div>

              {/* table */}
              <div className="mb-3">
                <KTTable
                  columns={fullColumns}
                  items={chargeModelList}
                  selectableRows={false}
                  striped={false}
                  compactGrid={false}
                  onClickedRow={(row) => { }}
                  onSelectedRowsChanged={(rows) => { }}
                  onDoubleClickedRow={(row) => { }}
                  noDataComponent={UIHelper.buildEmptyNoData(
                    'Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.'
                  )}
                />
              </div>

              {/* phan trang */}
              <KTPagination
                currentPage={filter.page + 1}
                rowCount={total}
                rowsPerPage={filter.limit}
                currentItemInPageCount={chargeModelList?.length}
                onChangePage={(newPage) => {
                  const iNewPage = parseInt(newPage);
                  ChargeHelper.Filter.chargeModelList = {
                    ...ChargeHelper.Filter.chargeModelList,
                    page: iNewPage - 1,
                  };
                  handleRefresh();
                }}
                onChangeRowsPerPage={(newRowsPerPage) => {
                  const iNewRowsPerPage = parseInt(newRowsPerPage);
                  ChargeHelper.Filter.chargeModelList = {
                    ...ChargeHelper.Filter.chargeModelList,
                    limit: iNewRowsPerPage,
                    page: 0,
                  };
                  handleRefresh();
                }}
                loading={isLoading}
                color={KTPaginationColor.success}
                appendText="dòng"
              />
            </div>
          </div>,
          false,
          !showFullUI
        )}
      </div>
    </div>
  );
}

export default ChargeModelListView;
